<div class="filter-form-container">
  @if (filtersLoading()) {
    <div class="skeleton-filters mobile-filters">
      <div class="skeleton-filter-select shimmer"><span>{{filterCategory.SPECIALTY}}</span></div>
      <div class="skeleton-more-filters shimmer">
        <span class="skeleton-icon-placeholder" aria-hidden="true"></span>
      </div>
    </div>
    <div class="skeleton-filters desktop-filters">
      <div class="skeleton-filter-select shimmer"><span>{{filterCategory.STATE}}</span></div>
      <div class="skeleton-filter-select shimmer"><span>{{filterCategory.THERAPY_OR_PSYCHIATRY}}</span></div>
      <div class="skeleton-filter-select shimmer"><span>{{filterCategory.INSURANCE}}</span></div>
      <div class="skeleton-filter-select shimmer"><span>{{filterCategory.SPECIALTY}}</span></div>
      <div class="skeleton-more-filters shimmer">
        <span class="skeleton-icon-placeholder" aria-hidden="true"></span>
      </div>
    </div>
  }
  @else {
    @if (isMobile()) {
      <form
        [formGroup]="filterFormGroup"
        class="mobile-filters"
      >
        <filter-select-mobile
          [filterFormGroup]="filterFormGroup"
          [placeholder]="filterCategory.SPECIALTY"
          [filterCategories]="concernsListMobile"
        >
        </filter-select-mobile>

        <filter-select-mobile
          [filterFormGroup]="filterFormGroup"
          placeholder="More filters"
          [filterCategories]="moreFiltersListMobile"
          icon="filter_list"
          data-test="more-filters-mobile"
        >
        </filter-select-mobile>
      </form>

      <provider-name-search
        [layout]="searchLayout.FULL_SCREEN"
        [internalDirectory]="internalDirectory()"
      ></provider-name-search>
    }
    @else if (isCompactDesktop()) {
      <form
        [formGroup]="filterFormGroup"
        class="compact-desktop-filters"
        [class.hidden]="isSearchPanelOpen()"
      >
        @for (config of visibleCompactFilters(); track config.category) {
          <filter-select-v2
            [formControl]="config.formControl"
            [placeholder]="config.category"
            [attr.data-test]="config.dataTest"
            [categorizedOptions]="config.options"
            [isMulti]="config.isMulti"
            [isSearchable]="config.isSearchable"
            [size]="config.size"
          >
          </filter-select-v2>
        }

        @if (overflowCompactFilters().length > 0) {
          <more-filters-v2
            [filterFormGroup]="filterFormGroup"
            [filterCategories]="overflowCompactFilters()"
            [alignRight]="false"
            data-test="more-filters-compact-desktop"
          >
          </more-filters-v2>
        }
      </form>

      <provider-name-search
        class="desktop-search"
        [layout]="searchLayout.INLINE"
        [internalDirectory]="internalDirectory()"
        [dropdownRevealDelayMs]="150"
        (panelOpenChange)="isSearchPanelOpen.set($event)"
        [class.expanded]="isSearchPanelOpen()"
      ></provider-name-search>
    }
    @else {
      <form
        [formGroup]="filterFormGroup"
        class="desktop-filters"
        [class.hidden]="isSearchPanelOpen()"
      >
        <filter-select-v2
          formControlName="state"
          [placeholder]="filterCategory.STATE"
          data-test="location"
          [categorizedOptions]="stateOptions"
          [isMulti]="false"
          [isSearchable]="true"
        >
        </filter-select-v2>

        <filter-select-v2
          formControlName="serviceType"
          [placeholder]="filterCategory.THERAPY_OR_PSYCHIATRY"
          data-test="therapy-or-psychiatry"
          [categorizedOptions]="serviceTypeOptions"
          [isMulti]="false"
          [isSearchable]="false"
          [size]="8"
        >
        </filter-select-v2>

        <filter-select-v2
          formControlName="insurance"
          [placeholder]="filterCategory.INSURANCE"
          data-test="insurance"
          [categorizedOptions]="insuranceOptions"
          [isMulti]="false"
          [isSearchable]="true"
          [size]="12"
        >
        </filter-select-v2>

        <filter-select-v2
          formControlName="specialties"
          [placeholder]="filterCategory.SPECIALTY"
          data-test="concerns"
          [categorizedOptions]="specialtyOptions"
          [isMulti]="true"
          [isSearchable]="true"
        >
        </filter-select-v2>

        <more-filters-v2
          [filterFormGroup]="filterFormGroup"
          [filterCategories]="moreFiltersListDesktop"
          data-test="more-filters-desktop"
        >
        </more-filters-v2>
      </form>

      <provider-name-search
        class="desktop-search"
        [layout]="searchLayout.INLINE"
        [internalDirectory]="internalDirectory()"
        [dropdownRevealDelayMs]="150"
        (panelOpenChange)="isSearchPanelOpen.set($event)"
        [class.expanded]="isSearchPanelOpen()"
      ></provider-name-search>
    }
  }
</div>

